// @flow
import React, { Fragment } from 'react';
import { DateLabel } from '@finect/tabular-components/DateLabel';
import { DropdownMenuAction } from '@finect/tabular-components/DropdownMenuAction';
import { MoreVertical } from '@finect/tabular-icons/moreVertical';
import { Eye } from '@finect/tabular-icons/eye';
import { FileText } from '@finect/tabular-icons/fileText';

import {
  Head,
  HeadInner,
  ItemHeadTitle,
  ItemHeadDate,
  ItemHeadAdviserDisplayName,
  ItemHeadStatus,
  ItemHeadMenuAction,
  Status
} from './partials';

export const ServiceHead = ({
  onToggle,
  onChangeView,
  service,
  title
}: {
  onToggle: Function,
  onChangeView: Function,
  service: Object,
  title: string
}) => {
  const headMenu =
    service.status === 'Completed' && !service.ratings.length
      ? [
        {
          name: 'status',
          text: 'Estado de la solicitud',
          icon: Eye
        },
        {
          name: 'form',
          text: 'Datos proporcionados',
          icon: FileText
        },
        {
          name: `feedback-${service.id}`,
          text: 'Valorar asesores',
          icon: FileText
        }
      ]
      : [
        {
          name: 'status',
          text: 'Estado de la solicitud',
          icon: Eye
        },
        {
          name: 'form',
          text: 'Datos proporcionados',
          icon: FileText
        }
      ];

  return (
    <Head>
      <HeadInner onClick={() => onToggle()}>
        <ItemHeadTitle>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="6" fill="#3C44D7" />
            <path
              d="M26.4118 19.8881C26.4118 20.1614 26.3308 20.4285 26.1791 20.6558C26.0273 20.883 25.8116 21.0601 25.5593 21.1647C25.3069 21.2693 25.0293 21.2966 24.7614 21.2433C24.4935 21.19 24.2474 21.0584 24.0543 20.8652C23.8611 20.6719 23.7296 20.4257 23.6763 20.1577C23.623 19.8896 23.6504 19.6118 23.7549 19.3593C23.8594 19.1068 24.0364 18.891 24.2635 18.7392C24.4906 18.5873 24.7576 18.5063 25.0308 18.5063C25.3971 18.5063 25.7483 18.6519 26.0073 18.911C26.2663 19.1701 26.4118 19.5216 26.4118 19.8881Z"
              fill="white"
            />
            <path
              d="M14.3892 25.1318C14.276 25.1319 14.1639 25.1096 14.0593 25.0663C13.9547 25.023 13.8597 24.9595 13.7796 24.8794C13.6996 24.7993 13.6361 24.7042 13.5928 24.5996C13.5495 24.4949 13.5273 24.3828 13.5273 24.2695V15.643C13.5272 15.4144 13.6177 15.1952 13.7789 15.0333L22.3995 6.4068C22.52 6.28606 22.6736 6.20381 22.8409 6.17048C23.0082 6.13715 23.1816 6.15422 23.3391 6.21955C23.4967 6.28488 23.6314 6.39551 23.726 6.53745C23.8207 6.67939 23.8712 6.84625 23.8711 7.0169V15.643C23.8713 15.7562 23.8492 15.8684 23.806 15.9731C23.7629 16.0778 23.6995 16.1729 23.6195 16.2531L14.9994 24.8796C14.9192 24.9596 14.8241 25.0231 14.7193 25.0663C14.6146 25.1095 14.5024 25.1316 14.3892 25.1313V25.1318ZM15.252 15.9999V22.1865L22.1479 15.2855V9.09942L15.252 15.9999Z"
              fill="#D5D5D6"
            />
            <path
              d="M23.01 33.7398C22.8968 33.7399 22.7847 33.7178 22.6801 33.6746C22.5755 33.6314 22.4804 33.568 22.4003 33.4881L13.7786 24.861C13.6175 24.6989 13.527 24.4795 13.5271 24.2509V15.6243C13.5272 15.4537 13.5778 15.287 13.6726 15.1452C13.7674 15.0034 13.9021 14.8928 14.0596 14.8276C14.2172 14.7624 14.3905 14.7453 14.5578 14.7786C14.725 14.8119 14.8786 14.8941 14.9992 15.0147L23.6193 23.6408C23.6992 23.721 23.7626 23.8161 23.8057 23.9208C23.8489 24.0255 23.871 24.1377 23.8708 24.2509V32.88C23.8709 32.9932 23.8487 33.1054 23.8055 33.2101C23.7622 33.3148 23.6987 33.4099 23.6187 33.49C23.5386 33.5701 23.4436 33.6336 23.339 33.6769C23.2343 33.7202 23.1222 33.7424 23.009 33.7423L23.01 33.7398ZM15.2507 23.8935L22.1467 30.7944V24.6083L15.2507 17.7074V23.8935Z"
              fill="white"
            />
          </svg>
          <ItemHeadAdviserDisplayName>{title}</ItemHeadAdviserDisplayName>
        </ItemHeadTitle>

        <ItemHeadDate date={true}>
          <DateLabel date={new Date(service.creationDate)} format={'LLLS'} />
        </ItemHeadDate>
      </HeadInner>
      <HeadInner onClick={() => onToggle()}>
        <ItemHeadStatus>
          <Fragment>
            <Status status={service.status}>
              {service.status === 'Unsold' ? 'Cancelado' : service.status === 'Completed' ? 'Finalizado' : 'Pendiente'}
            </Status>
            {service ? (
              <DateLabel
                date={
                  new Date(
                    service.adviserSentDate
                      ? service.adviserSentDate
                      : service.userSentDate
                        ? service.userSentDate
                        : service.creationDate
                  )
                }
                format={'LLLS'}
              />
            ) : null}
          </Fragment>
        </ItemHeadStatus>
        <ItemHeadMenuAction onClick={evt => evt.stopPropagation()}>
          <DropdownMenuAction onAction={action => onChangeView(action)} actions={headMenu}>
            <MoreVertical />
          </DropdownMenuAction>
        </ItemHeadMenuAction>
      </HeadInner>
    </Head>
  );
};
